<template>
  <v-navigation-drawer
    persistent
    :mini-variant="false"
    :clipped="true"
    enable-resize-watcher
    :fixed="false"
    :value="$store.state.ui.openLeftNavDrawer"
    app
  >
    <v-list dense>
      <v-subheader>Maintenance</v-subheader>
      <v-list-item-group>
        <v-list-item to="/admin/lookups">
          <v-list-item-action>
            <v-icon>list</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Lookups</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/options">
          <v-list-item-action>
            <v-icon>settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Options</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/conditions">
          <v-list-item-action>
            <v-icon>supervised_user_circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Conditions</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/qualifications">
          <v-list-item-action>
            <v-icon>school</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Qualifications</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/institutions">
          <v-list-item-action>
            <v-icon>business</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Institutions</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/hpifacilities">
          <v-list-item-action>
            <v-icon>business</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>HPI Facilities</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/postcodes">
          <v-list-item-action>
            <v-icon>map</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Post Codes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/fees">
          <v-list-item-action>
            <v-icon>attach_money</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Fees</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/scopes">
          <v-list-item-action>
            <v-icon>assignment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Scopes Of Practice</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/practicingstatusoptions">
          <v-list-item-action>
            <v-icon>assignment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>PracticingStatusOptions</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>

      <v-subheader>Users and Roles</v-subheader>
      <v-list-item-group>
        <v-list-item to="/admin/users">
          <v-list-item-action>
            <v-icon>people</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin/roles">
          <v-list-item-action>
            <v-icon>lock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Roles</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>

      <v-subheader>
        Reports
      </v-subheader>

      <v-list-item to="/admin/reports">
        <v-list-item-action>
          <v-icon>dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Reports (WIP)</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/payments">
        <v-list-item-action>
          <v-icon>mdi-credit-card-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Payments</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/hpi-extract">
        <v-list-item-action>
          <v-icon>people</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>HPI Extract</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/automatic-processes">
        <v-list-item-action>
          <v-icon>bolt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Automatic processes</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "adminLeftNavDrawer"
};
</script>
